import './StudentAssignment.scss';
import SearchAndSortableTable from '../../../../../../components/table/SearchAndSortableTable';
import { useAssignedStudentCoursesTable, useGetTableData } from './StudentAssignmentHooks';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onTableActionSuccess: () => null,
  loading: false,
};

const StudentAssignment = (p) => {
  const {
    data,
    onTableActionSuccess,
    loading,
  } = { ...defaultProps, ...filterUndefined(p) };
  const {
    tableConfig,
  } = useAssignedStudentCoursesTable({
    onTableActionSuccess,
  });

  const {
    tableData,
  } = useGetTableData({
    assignedStudentCourses: data.assignedStudentCourses,
  });

  return (
    <div className='student-assignment' data-test='student-assignment-table'>
      <SearchAndSortableTable
        config={tableConfig}
        tableData={tableData}
        initTableState={{
          order: 'desc', // needs to figure out whey it is 'desc' to order the date
          orderBy: 'studentName',
        }}
        filterable={false}
        loading={loading}
        autoResetTableState={false}
      />
    </div>
  );
};

export default StudentAssignment;
